// Document IDs used by the grant application document pages.
//
// The required/conditional documents on the Upload Documents page use a sequential
// range starting at 1. Everything that is NOT part of that required set gets a fixed
// ID out of that range so an uploaded file's ID stays stable no matter how the
// questionnaire shifts the sequence.

// Human Fetal Tissue paperwork, requested on the Upload Documents page only when
// the questionnaire answers "Yes" to human fetal tissue. Fixed IDs out of the
// sequential range so toggling the answer never renumbers the other documents,
// but still below 100 so they count as required.
export const HFT_COMPLIANCE_DOC_ID = 90;
export const HFT_IRB_CONSENT_DOC_ID = 91;

// Company Commercialization History, requested when the questionnaire says the
// company has received SBIR Phase II awards (SBIR question 9). Same fixed-ID
// reasoning as the HFT documents above.
export const COMMERCIALIZATION_HISTORY_DOC_ID = 92;

// Optional extras on the Upload Documents page
export const LETTERS_OF_SUPPORT_DOC_ID = 100;
export const ADDITIONAL_DOCUMENTS_DOC_ID = 101;

// Just-in-Time documents, requested after the application itself is complete.
export const JIT_DOCUMENT_ID_BASE = 200;
export const JIT_ADDITIONAL_DOCUMENTS_DOC_ID = 299;

// Notices of Award, uploaded once a grant is funded. There can be several — some
// agencies issue one per year — so every NOA shares this one ID and the page lists
// each uploaded record. Mirrored by NOTICE_OF_AWARD_DOC_ID in
// Backend/controllers/grantApplicationController.js.
export const NOTICE_OF_AWARD_DOC_ID = 300;

// The Just-in-Time documents share the grant application's document store, so both
// the progress bar on the Upload Documents page and the backend's
// "all required documents in?" check must ignore them.
export const isRequiredGrantDocumentId = (documentId) => {
  const id = Number(documentId);
  if (Number.isNaN(id)) return true;
  return id < LETTERS_OF_SUPPORT_DOC_ID;
};
